/** Только для DEMO_MODE / VITE_DEMO_MODE; не использовать на проде. */
export const DEMO_LOGIN_PASSWORD = 'password123'

export const DEMO_LOGIN_USERS = [
  { email: 'admin@easya.ru', labelKey: 'auth.demoUserAdmin' as const },
  { email: 'teacher@easya.ru', labelKey: 'auth.demoUserTeacher' as const },
  { email: 'student@easya.ru', labelKey: 'auth.demoUserStudent' as const },
] as const
